// @ts-expect-error - TS2614 - Module '"src/api-parsers"' has no exported member 'Workflow'. Did you mean to use 'import Workflow from "src/api-parsers"' instead?
import type {Workflow} from 'src/api-parsers';
// @ts-expect-error - TS2614 - Module '"src/api-parsers/events"' has no exported member 'Event'. Did you mean to use 'import Event from "src/api-parsers/events"' instead?
import type {Event} from 'src/api-parsers/events';
import type {RouteLocation, Params} from 'src/types/router';

import flow from 'lodash/flow';
import * as React from 'react';
import {connect} from 'react-redux';

import {provideHooks} from 'src/flux/provideHooks';
import {handleGenericApiError} from 'src/utils/errors';
import classify from 'src/utils/classify';

import styles from 'src/components/app.css';

import {
  VIEW_ANALYTICS,
  VIEW_WORKFLOWS,
  VIEW_AUDIENCE_MEMBERS,
  EDIT_WORKFLOWS,
  EDIT_SETTINGS,
  MANAGE_CALENDAR,
  MANAGE_TEAM_TEMPLATES,
  VIEW_REFERRALS_V2,
  EDIT_REFERRALS_V2,
  ADMIN_REFERRALS_V2,
  VIEW_SURVEYS,
} from 'src/action-creators/roles';
import {getWorkflows, getWorkflow} from 'src/actions/workflow';
import {fluxify} from 'src/flux/component';
import {hasPrivilege} from 'src/utils/accounts';
import {canUseMsgPhoneOrLatInbox, canUseMessaging} from 'src/selectors/chat';
import {selectReleaseFlags} from 'src/selectors/product-flags';
import {
  selectAgencyConfigFlag,
  selectEnableVoiceflowPage,
} from 'src/selectors/agency';
import {isChatAppLocation, isMobile} from 'src/utils/responsive';
import {withWindowWidth} from 'src/flux/responsive';
import {selectFullscreen} from 'src/selectors/app-config';
import ExtensionSideNav from 'src/components/micro-apps-extension/extension-side-nav';

import AppStatusNotification from './app-status-notification';
import SideNavigation from './side';
import {RerouterLocation} from 'src/rerouter';


const dependencies = {
  // @ts-expect-error - TS7031 - Binding element 'dispatch' implicitly has an 'any' type. | TS7031 - Binding element 'store' implicitly has an 'any' type. | TS7031 - Binding element 'location' implicitly has an 'any' type.
  required: async ({dispatch, store, location}) => {
    const workflowId = getWorkflowId(location);
    if (workflowId) {
      // @ts-expect-error - TS18046 - 'getWorkflow' is of type 'unknown'. | TS7006 - Parameter 'error' implicitly has an 'any' type.
      getWorkflow(store, dispatch, workflowId).catch((error) =>
        handleGenericApiError(error, [404]),
      );
    }
  },
  // @ts-expect-error - TS7031 - Binding element 'store' implicitly has an 'any' type.
  deferred: ({store}) => getWorkflows(store),
} as const;

const mapStateToProps = (state: any, ownProps: any) => ({
  canViewSurveys: hasPrivilege(state, VIEW_SURVEYS),
  canViewAnalytics: hasPrivilege(state, VIEW_ANALYTICS),
  canViewWorkflows: hasPrivilege(state, VIEW_WORKFLOWS),
  canEditWorkflows: hasPrivilege(state, EDIT_WORKFLOWS),
  canEditSettings: hasPrivilege(state, EDIT_SETTINGS),
  canViewChat: canUseMessaging(state),
  canViewChatorEditChatbot: canUseMsgPhoneOrLatInbox(state),
  canViewAudienceMembers: hasPrivilege(state, VIEW_AUDIENCE_MEMBERS),
  analyticsPerformancePageEnabled: selectAgencyConfigFlag(
    state,
    'analyticsPerformancePageEnabled',
  ),
  analyticsCohortsEnabled: selectAgencyConfigFlag(
    state,
    'analyticsCohortsEnabled',
  ),
  isMobile: isMobile(state.requestHeaders.headers['user-agent']),
  context: state.env.query.context,
  schedulingAllowed:
    hasPrivilege(state, MANAGE_CALENDAR) ||
    hasPrivilege(state, MANAGE_TEAM_TEMPLATES),
  schedulerEnabled: selectAgencyConfigFlag(state, 'enableSchedulerProduct'),
  hidden: state.navigation.sideNavHidden || ownProps.hidden,
  canViewReferrals:
    hasPrivilege(state, VIEW_REFERRALS_V2) ||
    hasPrivilege(state, EDIT_REFERRALS_V2) ||
    hasPrivilege(state, ADMIN_REFERRALS_V2),
  canViewVoiceflow: selectEnableVoiceflowPage(state),
  isFullscreenExperience: selectFullscreen(state),
  isMsgHvBroadcastEnabled: selectReleaseFlags(state)['messagingBroadcastV2'],
});

// @ts-expect-error - TS7031 - Binding element 'store' implicitly has an 'any' type. | TS7031 - Binding element 'location' implicitly has an 'any' type.
const mapper = ({store, location}) => {
  const workflowId = getWorkflowId(location);
  // @ts-expect-error TS2538
  const workflow = store.workflows.state.workflows[workflowId];
  const branchedEventIds = Array.isArray(workflow?.branchedEventIds)
    ? workflow.branchedEventIds
    : [];
  // @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type.
  const eventSchedule = workflow?.eventsSchedule?.map(({id}) => id) ?? [];
  const events = workflow
    ? [...branchedEventIds, ...eventSchedule]
        .map((id) => store.events.state.events[id])
        .filter((event) => event)
        .sort((a, b) =>
          a.title.localeCompare(b.title, 'en', {sensitivity: 'base'}),
        )
    : null;

  return {
    workflows: store.workflows.state.workflows,
    workflow,
    events,
    client: location.query.client,
    getWorkflows: () => getWorkflows(store),
  };
};

class WorkflowNav extends React.Component<{
  children: React.ReactNode;
  canViewAnalytics: boolean;
  canViewAudienceMembers: boolean;
  canViewWorkflows: boolean;
  canEditWorkflows: boolean;
  canEditSettings: boolean;
  canViewChat: boolean;
  canViewChatorEditChatbot: boolean;
  workflows: {
    [key: string]: Workflow;
  };
  workflow?: Workflow;
  events: Event[] | null | undefined;
  analyticsPerformancePageEnabled: boolean;
  analyticsCohortsEnabled: boolean;
  schedulingAllowed: boolean;
  schedulerEnabled: boolean;
  isMobileWindow: boolean;
  isMobile: boolean;
  context: string;
  getWorkflows: () => unknown;
  location: RouteLocation;
  params: Params;
  hidden: unknown | null | undefined;
  canViewReferrals: boolean;
  canViewVoiceflow: boolean;
  isFullscreenExperience: boolean;
  canViewSurveys: boolean;
  isMsgHvBroadcastEnabled: boolean;
}> {
  // @ts-expect-error - TS4114 - This member must have an 'override' modifier because it overrides a member in the base class 'Component<{ children: ReactNode; canViewAnalytics: boolean; canViewAudienceMembers: boolean; canViewWorkflows: boolean; canEditWorkflows: boolean; canEditSettings: boolean; canViewChat: boolean; ... 19 more ...; isMsgHvBroadcastEnabled: boolean; }, {}, any>'.
  componentDidMount() {
    if (Object.keys(this.props.workflows).length === 0) {
      this.props.getWorkflows();
    }
  }

  // @ts-expect-error - TS4114 - This member must have an 'override' modifier because it overrides a member in the base class 'Component<{ children: ReactNode; canViewAnalytics: boolean; canViewAudienceMembers: boolean; canViewWorkflows: boolean; canEditWorkflows: boolean; canEditSettings: boolean; canViewChat: boolean; ... 19 more ...; isMsgHvBroadcastEnabled: boolean; }, {}, any>'.
  render() {
    const {
      location,
      workflows,
      workflow,
      events,
      hidden,
      params,
      canViewAnalytics,
      canViewAudienceMembers,
      canViewWorkflows,
      canEditWorkflows,
      canEditSettings,
      canViewChat,
      canViewChatorEditChatbot,
      analyticsPerformancePageEnabled,
      analyticsCohortsEnabled,
      schedulingAllowed,
      schedulerEnabled,
      isMobileWindow,
      isMobile,
      context,
      canViewReferrals,
      canViewVoiceflow,
      isFullscreenExperience,
      canViewSurveys,
      isMsgHvBroadcastEnabled,
    } = this.props;
    const fullyHidden =
      context === 'chrome-extension' ||
      context === 'pwa' ||
      context === 'trm-iframe' ||
      context === 'client-iframe' ||
      context === 'sense-ai' ||
      isMobile ||
      (isChatAppLocation(location) && isMobileWindow) ||
      isFullscreenExperience;

    return (
      <div
        className={classify(styles.content, {
          [styles.extensionContent]: context === 'chrome-extension',
        })}
      >
        {!fullyHidden && (
          <SideNavigation
            {...{
              location,
              workflows,
              workflow,
              events,
              hidden: Boolean(hidden),
              canViewAnalytics,
              canViewAudienceMembers,
              canViewWorkflows,
              canEditWorkflows,
              canEditSettings,
              canViewChat,
              canViewChatorEditChatbot,
              analyticsPerformancePageEnabled,
              analyticsCohortsEnabled,
              schedulerEnabled,
              schedulingAllowed,
              params,
              canViewReferrals,
              canViewVoiceflow,
              canViewSurveys,
            }}
            className={styles.sideNav}
          />
        )}
        {/* TODO(Ashwini): To remove HVB check post gigroup migrates to HVB view */}
        {(context === 'chrome-extension' ||
          (context === 'client-iframe' && isMsgHvBroadcastEnabled)) && (
          <ExtensionSideNav />
        )}
        <div className={styles.child}>
          {!fullyHidden && <AppStatusNotification />}
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default flow(
  withWindowWidth,
  fluxify(mapper),
  connect(mapStateToProps),
  provideHooks(dependencies),
)(WorkflowNav) as any;

// TODO (kyle): since this component is placed high up the route tree,
// it does not have access to the workflowId param. this solution is a
// hacky stopgap.
function getWorkflowId(location: RerouterLocation) {
  const match = location.pathname.match(/\/journeys?\/(\d+)/);
  const workflowId = match && match[1];
  return workflowId;
}
